import React from 'react';
import formatSecondsShort from 'utils/formatSecondsShort';
import './HighlightPopover.styl';
import classNames from 'classnames';
import CallHistoryActions from 'actions/inbox/CallHistoryActions';
import chopAtWordBoundary from 'utils/chopAtWordBoundary';
import {stripHtmlWithSpaces} from 'utils/stripHtml';
import {htmlDecode} from 'components/triggers/BulletedMatchedRuleDescription';

export default function HighlightPopover({items}) {
  return (
    <div>
      <h2 className="popover-header">Highlights</h2>
      {items
        .sortBy(item => item.context.start)
        .map(item => (
          <div
            className={classNames(
              'history-action-item',
              'highlight-item',
              item.context.active ? '' : 'disabled'
            )}
            key={item.id}
            onMouseEnter={() =>
              item.context.active && CallHistoryActions.hoverHighlight(item.context.id)
            }
            onMouseOut={() => item.context.active && CallHistoryActions.unhoverHighlight()}>
            <div className={'color-disc'}>
              <svg height="14" width="14">
                <circle
                  cx="7"
                  cy="7"
                  r="6"
                  stroke="black"
                  strokeWidth="1"
                  fill={item.context.color}
                />
              </svg>
            </div>{' '}
            <div className={'timestamp'}>{formatSecondsShort(item.context.start)}</div>{' '}
            {displayText(item.context.reason)}
          </div>
        ))}
    </div>
  );
}

function displayText(text) {
  if (text === '<deleted>') {
    return text;
  } else {
    return chopAtWordBoundary(htmlDecode(stripHtmlWithSpaces(text)), 40);
  }
}
